var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuestion = function SvgQuestion(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M9.176 14.235a1.86 1.86 0 0 0-1.882 1.883c0 1.059.77 1.882 1.882 1.882a1.89 1.89 0 0 0 1.883-1.882 1.89 1.89 0 0 0-1.883-1.883M11.123 2H8.119A4.09 4.09 0 0 0 4 6.118c0 .764.647 1.411 1.412 1.411s1.412-.647 1.412-1.411c0-.706.535-1.294 1.24-1.294h3.007c.758 0 1.4.588 1.4 1.294 0 .47-.236.83-.648 1.064L8.471 9.235a1.45 1.45 0 0 0-.706 1.236v.94c0 .766.647 1.412 1.411 1.412.765 0 1.412-.646 1.412-1.411v-.118l2.653-1.647c1.236-.765 2-2.118 2-3.53C15.294 3.825 13.471 2 11.124 2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuestion);
export default ForwardRef;